$(document).ready(function () {
    $('[data-fancybox="posters"]').fancybox({
        touch: false,
        backFocus: false,
        wheel: false,
        loop: true,
        buttons: ["zoom", "close"]
    });
    $('[data-fancybox="sea-images"]').fancybox({
        touch: false,
        backFocus: false,
        wheel: false,
        loop: true,
        buttons: ["zoom", "close"]
    });
    $('[data-fancybox="mountain-images"]').fancybox({
        touch: false,
        backFocus: false,
        wheel: false,
        loop: true,
        buttons: ["zoom", "close"]
    });
});